import { render, staticRenderFns } from "./bankIdAuth.vue?vue&type=template&id=33a34aa7&scoped=true&"
import script from "./bankIdAuth.vue?vue&type=script&lang=js&"
export * from "./bankIdAuth.vue?vue&type=script&lang=js&"
import style0 from "./bankIdAuth.vue?vue&type=style&index=0&id=33a34aa7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a34aa7",
  null
  
)

export default component.exports